/* eslint-disable react-hooks/exhaustive-deps, jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import activityImg from "../../assets/activity.png";
import Button from "@mui/material/Button";
import {
  Box,
  Typography,
  Skeleton,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ActivityDetails from "./ActivityDetails";
import { useUser } from "../../hooks/Authorize";
import axios from "axios";
import { useTheme as useCustomTheme } from "../../style/theme";

const Activity = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const platformUser = useUser();
  const [loading, setLoading] = useState(true);

  // Responsive check on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // API call to fetch activity
  const getSubscription = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/store/subscription/history?userId=${platformUser?._id}`
      );
      const subscriptions = response?.data?.subscriptionHistory;
      setData(subscriptions);

      setLoading(false);
      console.log("Subscriptions:", subscriptions);
    } catch (error) {
      console.error("Failed to fetch subscriptions:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getSubscription();
  }, []);
  const { mode } = useCustomTheme();
  return (
    <>
      {loading ? (
        Array.from(new Array(5)).map((_, index) => (
          <Grid item xs={12} key={index}>
            <Card
              sx={{
                background: "none",
                border: mode === "light"
                ? "1px solid #e5e7eb"
                : "1px solid #2e2e2e",
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  alignItems: isMobile ? "flex-start" : "center",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "space-between",
                  gap: isMobile ? 2 : 0,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 2,
                    width: isMobile ? "100%" : "auto",
                  }}
                >
                  <Skeleton
                    variant="circular"
                    width={isMobile ? 50 : 70}
                    height={isMobile ? 50 : 70}
                  />
                  <Box>
                    <Skeleton variant="text" width={150} height={25} />
                    <Skeleton variant="text" width={250} height={20} />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: isMobile ? "flex-start" : "center",
                    flexDirection: "column",
                    gap: "10px",
                    mt: isMobile ? 2 : 0,
                    width: isMobile ? "100%" : "auto",
                    textAlign: isMobile ? "left" : "right",
                  }}
                >
                  <Skeleton variant="text" width={100} height={20} />
                  <Skeleton variant="text" width={60} height={20} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))
      ) : data?.length > 0 ? (
        <ActivityDetails data={data} />
      ) : (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: isMobile ? 2 : 4,
            py: isMobile ? 2 : 6,
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              color: "white",
              px: isMobile ? 1 : 4,
              py: isMobile ? 2 : 4,
              maxWidth: isMobile ? "100%" : "400px",
            }}
          >
            <Box sx={{ mb: isMobile ? 2 : 3 }}>
              <img
                src={activityImg}
                alt="activity"
                style={{ width: isMobile ? 70 : 100, height: "auto" }}
              />
            </Box>

            <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ mb: 1 }}>
              Manage your recent purchases with ease
            </Typography>

            <Typography
              variant="body2"
              color="gray"
              sx={{ mb: 2, fontSize: isMobile ? "12px" : "14px" }}
            >
              Track, review, and take action on your latest purchases in one
              convenient place.
            </Typography>

            <Button
              onClick={() => navigate("/myStore")}
              variant="contained"
              sx={{
                backgroundColor: "#0066ff",
                textTransform: "none",
                fontSize: isMobile ? "13px" : "16px",
                px: isMobile ? 4 : 6,
                py: 1,
                "&:hover": {
                  backgroundColor: "#0056cc",
                },
              }}
            >
              My Store
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Activity;
